import {Injector, NgModule} from '@angular/core';
import {CommonModule, DatePipe} from '@angular/common';

import {AuthComponent} from './auth/auth.component';
import {HttpClient, HttpClientModule} from '@angular/common/http';
import {DashboardComponent} from './main/dashboard/dashboard.component';
import {LoginComponent} from './auth/login/login.component';
import {VersionComponent} from './auth/version/version.component';
import {NgxPermissionsModule} from 'ngx-permissions';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {AppComponent} from './app.component';
import {AppRouteModule} from './app.route.module';
import {ResetComponent} from './auth/reset/reset.component';
import {BrowserModule} from '@angular/platform-browser';
import {MainComponent} from './main/main.component';
import {InfluencerService} from './services/influencer/influencer.service';
import {DiscoverComponent} from './main/discover/discover.component';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';

import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {AchooDropdownComponent} from './core/achoo-dropdown/achoo-dropdown.component';
import {AchooCheckboxComponent} from './core/achoo-checkbox/achoo-checkbox.component';
import {AchooToggleSwitchComponent} from './core/achoo-toggle-switch/achoo-toggle-switch.component';
import {AchooFilterBoxComponent} from './core/achoo-filter-box/achoo-filter-box.component';
import {NgSelectModule} from '@ng-select/ng-select';
import {ReferenceDataService} from './services/reference-data/reference-data.service';
import {GroupService} from './services/group-details/group.service';
import {GroupDetailsComponent} from './main/group-details/group-details.component';
import {GroupDetailsBreadcumbComponent} from './main/group-details/group-details-breadcumb/group-details-breadcumb.component';
import {SearchBarComponent} from './main/group-details/search-bar/search-bar.component';
import {InfluencerItemComponent} from './main/group-details/influencer-item/influencer-item.component';
import {AchooTextFieldComponent} from './core/achoo-text-field/achoo-text-field.component';
import {AchooPopupComponent} from './core/achoo-popup/achoo-popup.component';
import {InfluencerGroupsComponent} from './main/influencer-groups/influencer-groups.component';
import {InfluencerGroupsService} from './main/influencer-groups/influencer-groups.service';
import {AchooUserAvatarComponent} from './core/achoo-user-avatar/achoo-user-avatar.component';
import {AddInfluencerGroupComponent} from './main/group-details/add-influencer-group/add-influencer-group.component';
import {AutoSuggestionInfluencerComponent} from './main/group-details/auto-suggestion-influencer/auto-suggestion-influencer.component';
import {AchooTextareaComponent} from './core/achoo-textarea/achoo-textarea.component';
import {InfluencerComponent} from './main/influencer/influencer.component';
import {InfluencerOverviewComponent} from './main/influencer/influencer-overview/influencer-overview.component';
import {NgMasonryGridModule} from 'ng-masonry-grid';
import {PostListComponent} from './main/influencer/post-list/post-list.component';
import {ChartModule} from 'angular2-highcharts';
import {AchooPieChartComponent} from './core/achoo-pie-chart/achoo-pie-chart.component';
import {AchooColumnChartComponent} from './core/achoo-column-chart/achoo-column-chart.component';
import {InfluencerBasicInformationComponent} from './main/influencer-basic-information/influencer-basic-information.component';
import {
  CurrencyPipe, CurrencySymbolismPipe,
  FileSizePipe,
  FormatNumberToStringPipe,
  PercentNumberSuffixPipe,
  ThousandNumberSuffixPipe,
  FormatInteractionNumberPipe,
  FormatInteractionPercentagePipe, UserUsagePipe, ImpactFilterSuffixPipe
} from './pipes/custom-number-format.pipe';
import {HighchartsStatic} from 'angular2-highcharts/dist/HighchartsService';
import {GroupItemComponent} from './main/influencer-groups/group-item/group-item.component';
import {AchooMaterialInputComponent} from './core/achoo-material-input/achoo-material-input.component';
import {AchooMaterialTextareaComponent} from './core/achoo-material-textarea/achoo-material-textarea.component';
import {GaugeCircleChartComponent} from './main/influencer/influencer-insight/gauge-circle-chart/gauge-circle-chart.component';
import {InfluencerInsightComponent} from './main/influencer/influencer-insight/influencer-insight.component';
import {PlatformReacheComponent} from './main/influencer/influencer-insight/platform-reache/platform-reache.component';
import {TopExposuresComponent} from './main/influencer/influencer-insight/top-exposures/top-exposures.component';
import {TopExposureItemComponent} from './main/influencer/influencer-insight/top-exposures/top-exposure-item/top-exposure-item.component';
import {BestPerformingExposureComponent} from './main/influencer/influencer-insight/best-performing-exposure/best-performing-exposure.component';
import {BestPerformingExposureItemComponent} from './main/influencer/influencer-insight/best-performing-exposure/best-performing-exposure-item/best-performing-exposure-item.component';
import {TopMentionComponent} from './main/influencer/top-mention/top-mention.component';
import {CommonService} from './services/common/common.service';
import {PostOverviewComponent} from './main/post-overview/post-overview.component';
import {PostContentComponent} from './main/post-overview/post-content/post-content.component';
import {SameInfluencerTopFivePostsComponent} from './main/post-overview/same-influencer-top-five-posts/same-influencer-top-five-posts.component';
import {RelatedPostsComponent} from './main/post-overview/related-posts/related-posts.component';
import {InfluencerPostService} from './services/influencer-post/influencer-post.service';
import {CampaignService} from './services/campaign/campaign.service';
import {KpiReportComponent} from './main/kpi-report/kpi-report.component';
import {AchooGaugeCircleChartComponent} from './core/achoo-gauge-circle-chart/achoo-gauge-circle-chart.component';
import {AchooLineChartComponent} from './core/achoo-line-chart/achoo-line-chart.component';
import {InfluencerDemographicsComponent} from './main/influencer/influencer-demographics/influencer-demographics.component';
import {UserService} from './services/user.service';
import {AuthorizeService} from './services/authorize.service';
import {ForgotPasswordService} from './services/forgot-password.service';
import {AuthService} from './core/auth.service';
import {ThemeService} from './core/theme.service';
import {AuthGuard} from './core/auth.guard';
import {GenderPerAgeChartComponent} from './main/influencer/influencer-demographics/gender-per-age-chart/gender-per-age-chart.component';
import {CampaignsAddComponent} from './main/campaigns-add/campaign-add.component';
import {AchooChipsComponent} from './core/achoo-chips/achoo-chips.component';
import {CampaignsComponent} from './main/campaigns/campaigns.component';
import {CampaignItemComponent} from './main/campaigns/campaign-item/campaign-item.component';
import {CampaignInfluencersItemComponent} from './main/campaigns/campaign-influencers-item/campaign-influencers-item.component';
import {CampaignInfluencersListComponent} from './main/campaigns/campaign-influencers-list/campaign-influencers-list.component';
import {AddInfluencerCampaignComponent} from './main/campaigns/add-influencer-campaign/add-influencer-campaign.component';
import {AchooTabsComponent} from './core/achoo-tabs/achoo-tabs.component';
import {AchooTabComponent} from './core/achoo-tabs/achoo-tab/achoo-tab.component';
import {TabInkBarDirective} from './core/achoo-tabs/tab-ink-bar.directive';
import {TabLabelWrapperDirective} from './core/achoo-tabs/tab-label-wrapper.directive';
import {RouterModule} from '@angular/router';
import {SelectableCampaignTermsComponent} from './main/campaigns-add/selectable-campaign-terms/selectable-campaign-terms.component';
import {CampaignTermComponent} from './main/campaigns-add/campaign-term/campaign-term.component';
import {UploadFileComponent} from './main/campaigns-add/upload-file/upload-file.component';
import {ContenteditableDirective} from './main/campaigns-add/contenteditable.directive';
import {SpinnerComponent} from './main/campaigns-add/spinner/spinner.component';
import {MentionService} from './services/mention/mention.service';
import {AchooModalDialogModule} from './core/achoo-modal-dialog/achoo-modal-dialog.module';
import {CampaignsEditComponent} from './main/campaigns-add/campaign-edit.component';
import {AchooChipComponent} from './core/achoo-chip/achoo-chip.component';
import {MockBaseService} from './core/mock-base.service';
import {BaseService} from './core/base.service';
import {FilterInfluencerGroupNameSuffixPipe, FilterDataByIdPipe} from './pipes/custom-filter.pipe';
import {DiscoverSearchComponent} from './main/discover/discover-search/discover-search.component';
import {DiscoverService} from './services/discover/discover.service';
import {AchooPlaceholderComponent} from './core/achoo-placeholder/achoo-placeholder.component';
import {PlaceholderVisibilityService} from './services/placeholder-visibility/placeholder-visibility.service';
import {AchooLoaderComponent} from './core/achoo-loader/achoo-loader.component';
import {NgHttpLoaderModule} from 'ng-http-loader/ng-http-loader.module';
import { AdminComponent } from './main/admin/admin.component';
import { AchooIframeComponent } from './core/achoo-iframe/achoo-iframe.component';
import { UserProfileComponent } from './main/user/user-profile/user-profile.component';
import { InfluencerCampaignComponent } from './main/influencer-campaign/influencer-campaign.component';
import {MeasureComponent} from './main/measure/measure.component';
import {MeasureBreadcumbComponent} from './main/measure/measure-breadcumb/measure-breadcumb.component';
import {MeasureFilterComponent} from './main/measure/measure-filter/measure-filter.component';
import {MeasureModulesSelectionComponent} from './main/measure/measure-modules-selection/measure-modules-selection.component';
import {MeasureService} from './services/measure/measure.service';
import {TabHeadingDirective} from './core/achoo-tabs/tab-heading.directive';
import {NgTranscludeDirective} from './core/achoo-tabs/ng-transclude.directive';
import {AchooInfiniteScrollComponent} from './core/achoo-infinite-scroll/achoo-infinite-scroll.component';
import {InfiniteScrollModule} from 'ngx-infinite-scroll';
import {NgbActiveModal, NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {ModalService} from '../app/services/modal/modal.service';
import {PreviewSelectedInfluencersComponent} from './main/group-details/preview-selected-influencers/preview-selected-influencers.component';
import {AddInfluencersToCampaignComponent} from './main/group-details/add-influencers-to-campaign/add-influencers-to-campaign.component';
import {PreviewInfluencerItemComponent} from './main/group-details/preview-selected-influencers/preview-influencer-item/preview-influencer-item.component';
import {MoveInfluencerFromGroupComponent} from './main/group-details/move-influencer-from-group/move-influencer-from-group.component';
import {ActivityFiltersComponent} from './main/group-details/search-bar/activity-filters/activity-filters.component';
import {AchooSliderComponent} from './core/achoo-slider/achoo-slider.component';
import {IonRangeSliderModule} from 'ng2-ion-range-slider';
import {ClickOutsideModule} from 'ng-click-outside';
import {AchooValidationAlertsComponent} from './core/achoo-validation-alerts/achoo-validation-alerts.component';
import {ValidationHandlerService} from './core/validation-handler.service';
import { AverageBenchmarkPerformanceReportComponent } from './main/measure/contents/average-benchmark-performance-report/average-benchmark-performance-report.component';
import { MentionTimelineReportComponent } from './main/measure/contents/mention-timeline-report/mention-timeline-report.component';
import { AchooStackedColumnChartComponent } from './core/achoo-stacked-column-chart/achoo-stacked-column-chart.component';
import { InteractionReportComponent } from './main/measure/contents/interaction-report/interaction-report.component';
import { InteractionReportItemComponent } from './main/measure/contents/interaction-report/interaction-report-item/interaction-report-item.component';
import {ChannelOpportunitiesReportComponent} from './main/measure/contents/channel-opportunities-report/channel-opportunities-report.component';
import {MeasureSettingComponent} from './main/measure/measure-setting/measure-setting.component';
import { MarketDrillDownComponent } from './main/measure/content/market-drill-down/market-drill-down.component';
import { AchooGaugeCircleChartContentComponent } from './core/achoo-gauge-circle-chart-content/achoo-gauge-circle-chart-content.component';
import { RoiReportComponent } from './main/measure/content/roi-report/roi-report.component';
import { TopicDrillDownComponent } from './main/measure/topic-drill-down/topic-drill-down.component';
import { ListGaugeCircleChartComponent } from './core/list-gauge-circle-chart/list-gauge-circle-chart.component';
import { IndustryDrillDownReportComponent } from './main/measure/industry-drill-down-report/industry-drill-down-report.component';
import { InfluencerOverviewReportComponent } from './main/measure/influencer-overview-report/influencer-overview-report.component';
import { InfluencerSummarizeComponent } from './main/measure/influencer-overview-report/influencer-summarize/influencer-summarize.component';
import { ExposureKpiReportComponent } from './main/measure/exposure-kpi-report/exposure-kpi-report.component';
import { AchooKpiReportItemComponent } from './core/achoo-kpi-report-item/achoo-kpi-report-item.component';
import { BestPerformingInfluencerComponent } from './main/measure/best-performing-influencer/best-performing-influencer.component';
import { TopPerformingInfluencerComponent } from './main/measure/best-performing-influencer/top-performing-influencer/top-performing-influencer.component';
import {NgDragDropModule} from 'ng-drag-drop';
import { MeasureContentComponent } from './main/measure/measure-content/measure-content.component';
import { ProjectSelectionComponent } from './main/measure/project-selection/project-selection.component';
import { EditProjectComponent } from './main/measure/edit-project/edit-project.component';
import { AchooKeyworkInputFieldComponent } from './core/achoo-keywork-input-field/achoo-keywork-input-field.component';
import {ProjectService} from './services/project/project.service';
import {BottombarInfluencerFragementComponent} from './main/bottombar-influencer-fragement/bottombar-influencer-fragement.component';
import {NgxPopperModule} from 'ngx-popper';
import { BillingComponent } from './main/user/billing/billing.component';
import { ChangePasswordComponent } from './main/user/change-password/change-password.component';
import { InfluencerOverviewPostContentComponent } from './main/influencer/post-list/influencer-overview-post-content/influencer-overview-post-content.component';
import { AddPostsToProjectComponent } from './main/bottombar-influencer-fragement/add-posts-to-project/add-posts-to-project.component';
import { CacheService } from './services/cache/cache.service';
import {ServiceLocator} from './service-locator';
import { PreviewFileComponent } from './main/campaigns-add/upload-file/preview-file/preview-file.component';
import { CreateGroupFragmentComponent } from './main/influencer-groups/create-group-fragment/create-group-fragment.component';
import { OrderBarComponent } from './main/discover/order-bar/order-bar.component';
import { AchooPaginationComponent } from './core/achoo-pagination/achoo-pagination.component';
import { InfluencerCampaignActivityComponent } from './main/influencer/influencer-campaign-activity/influencer-campaign-activity.component';
import { CampaignInfluencerStatusSliderComponent } from './main/influencer/influencer-campaign-activity/campaign-influencer-status-slider/campaign-influencer-status-slider.component';
import { CampaignInfluencerPostsComponent } from './main/influencer/influencer-campaign-activity/campaign-influencer-posts/campaign-influencer-posts.component';
import { RoiSettingComponent } from './main/measure/content/roi-report/roi-setting/roi-setting.component';
import { CampaignCustomTermDetailsComponent } from './main/campaigns-add/campaign-custom-term-details/campaign-custom-term-details.component';
import { RegisterComponent } from './auth/register/register.component';
import {TelephoneNumberFormatDirective} from './auth/register/telephoneNumberFormat.directive';
import { RequestDemoComponent } from './auth/register/request-demo.component';
import {LoginGuard} from './core/login.guard';
import { PdfViewerComponent } from './main/pdf-viewer/pdf-viewer.component';
import { InfluencerDetailPdfViewerComponent } from './main/pdf-viewer/influencer-detail-pdf-viewer/influencer-detail-pdf-viewer.component';
import { PdfViewerHeaderComponent } from './main/pdf-viewer/pdf-viewer-header/pdf-viewer-header.component';
import { PdfViewerFooterComponent } from './main/pdf-viewer/pdf-viewer-footer/pdf-viewer-footer.component';
import { PostOverviewPdfViewerComponent } from './main/pdf-viewer/post-overview-pdf-viewer/post-overview-pdf-viewer.component';
import { PdfViewerService } from './main/pdf-viewer/pdf-viewer.service';
import { PlatformSettingsComponent } from './main/admin/platform-settings/platform-settings.component';
import { AchooColorPickerComponent } from './core/achoo-color-picker/achoo-color-picker.component';
import { AchooDropzoneComponent } from './core/achoo-dropzone/achoo-dropzone.component';
import {DROPZONE_CONFIG, DropzoneConfigInterface, DropzoneModule} from 'ngx-dropzone-wrapper';
import {ColorPickerModule} from 'ngx-color-picker';
import { AchooColorFieldComponent } from './core/achoo-color-field/achoo-color-field.component';
import { ListPlatformReachComponent } from './main/influencer/influencer-insight/list-platform-reach/list-platform-reach.component';
import { PlatformReachItemComponent } from './main/influencer/influencer-insight/list-platform-reach/platform-reach-item/platform-reach-item.component';
import { MeasurePdfViewerComponent } from './main/pdf-viewer/measure-pdf-viewer/measure-pdf-viewer.component';
import {PdfExportService} from './services/export-pdf/pdf-export.service';
import {PdfGuard} from './core/pdf.guard';
import {PdfDeactivateGuard} from './core/pdfDeactivate.guard';
import { DemographicHypeAuditorComponent } from './main/influencer/demographic-hype-auditor/demographic-hype-auditor.component';
import { AchooBarChartComponent } from './core/achoo-bar-chart/achoo-bar-chart.component';
import { DemographicComponent } from './main/influencer/demographic/demographic.component';
import { DemographicSourceSelectionComponent } from './main/influencer/demographic/demographic-source-selection/demographic-source-selection.component';
import { AchooPieChartPlacholderComponent } from './core/achoo-pie-chart-placholder/achoo-pie-chart-placholder.component';
import { DemographicFallbackComponent } from './main/influencer/demographic-fallback/demographic-fallback.component';
import { PayAsYouGoComponent } from './main/user/billing/pay-as-you-go/pay-as-you-go.component';
import { CreditSummaryComponent } from './main/user/billing/pay-as-you-go/credit-summary/credit-summary.component';
import { ActivityPricingComponent } from './main/user/billing/pay-as-you-go/activity-pricing/activity-pricing.component';
import { CreditUsageComponent } from './main/user/billing/pay-as-you-go/credit-usage/credit-usage.component';
import { BillingDetailsComponent } from './main/user/billing/pay-as-you-go/billing-details/billing-details.component';
import { PayAsYouGoBreadcumbComponent } from './main/user/billing/pay-as-you-go/pay-as-you-go-breadcumb/pay-as-you-go-breadcumb.component';
import { UsageItemComponent } from './main/user/billing/pay-as-you-go/credit-usage/usage-item/usage-item.component';
import { ListInvoicesComponent } from './main/user/billing/pay-as-you-go/list-invoices/list-invoices.component';
import { InvoiceItemComponent } from './main/user/billing/pay-as-you-go/list-invoices/invoice-item/invoice-item.component';
import {CreditBaseBillingService} from './services/credit-based-billing/credit-base-billing.service';
import {UserBillingGuard} from './core/user-billing.guard';
import { CreditUsageListComponent } from './main/admin/manage-user-credit/credit-usage-list/credit-usage-list.component';
import { InvoiceListComponent } from './main/admin/manage-user-credit/invoice-list/invoice-list.component';
import { AchooDatepickerComponent } from './core/achoo-datepicker/achoo-datepicker.component';
import { ManageUserCreditComponent } from './main/admin/manage-user-credit/manage-user-credit.component';
import { ManageUserAndBillingComponent } from './main/admin/manage-user-and-billing/manage-user-and-billing.component';
import { AdminService } from './services/admin/admin.service';
import { UpdateCreditUsageComponent } from './main/admin/manage-user-credit/update-credit-usage/update-credit-usage.component';
import { AddUserCreditComponent } from './main/admin/manage-user-credit/add-user-credit/add-user-credit.component';
import { UploadInvoiceComponent } from './main/admin/manage-user-credit/upload-invoice/upload-invoice.component';
import { AddInfluencerManuallyComponent } from './main/influencer/add-influencer-manually/add-influencer-manually.component';
import { ServiceWorkerModule } from '@angular/service-worker';

// Import the Segment module
import { SegmentModule } from 'ngx-segment-analytics';
import {EventTrackerService} from './services/event-tracker/event-tracker.service';
import {environment} from '../environments/environment';
import { AchooRadioButtonComponent } from './core/achoo-radio-button/achoo-radio-button.component';
import { StatusInfluencerSuggestionComponent } from './main/group-details/add-influencer-group/status-influencer-suggestion/status-influencer-suggestion.component';
import { TopMentionPlaceholderComponent } from './main/influencer/top-mention-placeholder/top-mention-placeholder.component';
import { AchooColumnChartPlaceholderComponent } from './core/achoo-column-chart-placeholder/achoo-column-chart-placeholder.component';
import { AudienceFilterComponent } from './main/discover/discover-search/audience-filter/audience-filter.component';
import { InterestFilterComponent } from './main/discover/discover-search/interest-filter/interest-filter.component';
import { OonaReportComponent } from './main/measure/contents/oona-report/oona-report.component';
import { OonaReportItemComponent } from './main/measure/contents/oona-report/oona-report-item/oona-report-item.component';
import { AchooIndexStatusComponent } from './core/achoo-index-status/achoo-index-status.component';
import {CheckAccountLevelsDirective} from './directive/check-account-levels.directive';
import { PlatformReachPlaceholderComponent } from './main/influencer/influencer-insight/platform-reach-placeholder/platform-reach-placeholder.component';
import { BestPerformingExposurePlaceholderComponent } from './main/influencer/influencer-insight/best-performing-exposure-placeholder/best-performing-exposure-placeholder.component';
import { AchooGaugeChartPlaceholderComponent } from './core/achoo-gauge-chart-placeholder/achoo-gauge-chart-placeholder.component';
import { LatestPostItemPlaceholderComponent } from './main/influencer/influencer-insight/latest-posts-placeholder/latest-post-item-placeholder/latest-post-item-placeholder.component';
import { TopExposurePlaceholderComponent } from './main/influencer/influencer-insight/top-exposure-placeholder/top-exposure-placeholder.component';
import { TopExposureItemPlaceholderComponent } from './main/influencer/influencer-insight/top-exposure-placeholder/top-exposure-item-placeholder/top-exposure-item-placeholder.component';
import { AchooBarChartPlaceholderComponent } from './core/achoo-bar-chart-placeholder/achoo-bar-chart-placeholder.component';
import { TopPostPlaceholderComponent } from './main/post-overview/same-influencer-top-five-posts/top-post-placeholder/top-post-placeholder.component';
import {LevelsGuard} from './core/levels.guard';
import { SignUpComponent } from './auth/sign-up/sign-up.component';
import { VerifyNewAccountComponent } from './auth/verify-new-account/verify-new-account.component';
import { SignUpFormComponent } from './auth/sign-up/sign-up-form/sign-up-form.component';
import { ConfirmPasswordComponent } from './auth/confirm-password/confirm-password.component';
import { AddNotesComponent } from './main/influencer/add-notes/add-notes.component';
import { InlineEditNoteComponent } from './main/influencer/inline-edit-note/inline-edit-note.component';
import { AchooStoryPreviewComponent } from './core/achoo-story-preview/achoo-story-preview.component';
import { AchooDatepickerRangeComponent } from './core/achoo-datepicker-range/achoo-datepicker-range.component';
import { MeasureDateRangeSelectionComponent } from './main/measure/measure-date-range-selection/measure-date-range-selection.component';
import {MeasureModuleDropdownComponent} from './main/measure/measure-module-dropdown/measure-module-dropdown.component';
import { FbTestingPageComponent } from './fb-testing-page/fb-testing-page.component';
import { FbLoginFailComponent } from './fb-testing-page/fb-login-fail/fb-login-fail.component';
import { CampaignPostListComponent } from './fb-testing-page/campaign-post-list/campaign-post-list.component';
import { CampaignPostItemComponent } from './fb-testing-page/campaign-post-item/campaign-post-item.component';
import { InfluencerDetailsComponent } from './influencer-platform/influencer-details/influencer-details.component';
import {InfluencerGuard} from './core/influencer.guard';
import { AchooIconTooltipComponent } from './core/achoo-icon-tooltip/achoo-icon-tooltip.component';
import { CampaignNewComponent } from './main/campaign-new/campaign-new.component';
import { CampaignDetailsComponent } from './main/campaign-new/campaign-details/campaign-details.component';
import { InfoGroupComponent } from './main/campaign-new/info-group/info-group.component';
import { CampaignStatusSliderComponent } from './main/campaign-new/campaign-status-slider/campaign-status-slider.component';
import { InfluencerSignUpComponent } from './influencer-auth/influencer-sign-up/influencer-sign-up.component';
import { InfluencerLoginComponent } from './influencer-auth/influencer-login/influencer-login.component';
import { InfluencerAuthComponent } from './influencer-auth/influencer-auth.component';
import { InfluencerInboxComponent } from './main/influencer-inbox/influencer-inbox.component';
import { InfluencerCampaignDetailComponent } from './influencer-platform/influencer-campaign-detail/influencer-campaign-detail.component';
import { InfluencerSettingsComponent } from './influencer-platform/influencer-settings/influencer-settings.component';
import { InfluencerMainComponent } from './influencer-main/influencer-main.component';
import {InfluencerOverviewTabComponent} from './influencer-platform/influencer-details/influencer-overview-tab/influencer-overview-tab.component';
import { AddScriptBlogComponent } from './influencer-platform/influencer-settings/add-script-blog/add-script-blog.component';
import { ForwardComponent } from './core/forward/forward.component';
import { MeasurePdfExportComponent } from './main/measure/measure-pdf-export/measure-pdf-export.component';
import { PageCountItemComponent } from './main/measure/measure-pdf-export/page-count-item/page-count-item.component';
import { AchooModalComponent } from './influencer-platform/influencer-settings/achoo-modal/achoo-modal.component';
import { PlatformFieldComponent } from './influencer-platform/influencer-settings/platform-field/platform-field.component';
import { ImagePrepoadDirective } from './core/image-preload.directive';
import { ConservationListComponent } from './main/influencer-inbox/conversation-list/conversation-list.component';
import { ConversationItemComponent } from './main/influencer-inbox/conversation-item/conversation-item.component';
import { CommunicationService } from './services/communication/communication.service';
import { InfluencerChatComponent } from './main/influencer-inbox/influencer-chat/influencer-chat.component';
import { InfluencerHomeComponent } from './main/influencer-home/influencer-home.component';
import { DashboardOrderBarComponent } from './main/influencer-home/influencer-home-order-bar/influencer-home-order-bar.component';
import { RecentMessagesComponent } from './main/influencer-home/recent-messages/recent-messages.component';
import { ShortMessageComponent } from './main/influencer-home/short-message/short-message.component';
import { DashboardService } from './services/dashboard/dashboard.service';
import { OverviewService } from './services/overview/overview.service';
import { MessagePopupComponent } from './main/influencer-home/message-popup/message-popup.component';
import { PlatformSelectComponent } from './influencer-platform/influencer-details/influencer-overview-tab/platform-select/platform-select.component';
import { InfluencerInsightModalComponent } from './main/influencer/influencer-insight/influencer-insight-modal/influencer-insight-modal.component';
import {InfluencerOverviewDetailPopupComponent} from './influencer-platform/influencer-details/influencer-overview-tab/influencer-overview-detail-popup/influencer-overview-detail-popup.component';
import { PostListMansonryComponent } from './main/influencer/post-list-mansonry/post-list-mansonry.component';
import {ChatScrollerDirective} from './directive/chat-scroller-directive';
import { CampaignPdfViewerComponent } from './main/pdf-viewer/campaign-pdf-viewer/campaign-pdf-viewer.component';
import {CampaignGuard} from './core/campaign.guard';
import { InfluencerConnectionComponent } from './influencer-platform/influencer-connection/influencer-connection.component';
import {FbAuthSuccessDeligatorComponent} from './core/fb-auth-success-deligator/fb-auth-success-deligator.component';
import { CampaignAcceptionPopupComponent } from './influencer-platform/campaign-acception-popup/campaign-acception-popup.component';
import { InfluencerAllSetComponent } from './influencer-platform/influencer-all-set/influencer-all-set.component';
import { ContactPermissionComponent } from './influencer-platform/contact-permission/contact-permission.component';
import { ContactPermissionDetailComponent } from './influencer-platform/contact-permission/contact-permission-detail/contact-permission-detail.component';
import { InfluencerConfirmationComponent } from './influencer-platform/influencer-details/influencer-confirmation/influencer-confirmation.component';
import { InfluencerDeclineModalComponent } from './influencer-platform/influencer-details/influencer-decline-modal/influencer-decline-modal.component';
import { FailRetrieveCampaignModalComponent } from './influencer-platform/influencer-details/fail-retrieve-campaign-modal/fail-retrieve-campaign-modal.component';
import { SignUpErrorComponent } from './auth/sign-up-error/sign-up-error.component';
import { InfluencerListComponent } from './main/influencer-list/influencer-list.component';
import { MonthlyVisitedBreadcrumbComponent } from './main/group-details/monthly-visited-breadcrumb/monthly-visited-breadcrumb.component';
import { InvalidAccountLevelNotificationComponent } from './main/invalid-account-level-notification/invalid-account-level-notification.component';
import { SendToReviewComponent } from './main/bottombar-influencer-fragement/send-to-review/send-to-review.component';
import { NewKpiComponent } from './main/influencer/new-kpi/new-kpi.component';
import { NewKpiItemComponent } from './main/influencer/new-kpi/new-kpi-item/new-kpi-item.component';
import { UserBillingComponent } from './main/user/user-billing/user-billing.component';
import { AccountTypeComponent } from './main/user/user-billing/account-type/account-type.component';
import { AccountSettingComponent } from './main/account-setting/account-setting.component';
import { UserDetailsComponent } from './main/account-setting/user-settings/user-details/user-details.component';
import { ChangePwdComponent } from './main/account-setting/user-settings/change-pwd/change-pwd.component';
import { UserSettingsComponent } from './main/account-setting/user-settings/user-settings.component';
import { DemographicGenderChartComponent } from './main/influencer/demographic/demographic-gender-chart/demographic-gender-chart.component';
import { NewGenderPerAgeChartComponent } from './main/influencer/influencer-demographics/new-gender-per-age-chart/new-gender-per-age-chart.component';
import { NewInfluencerDemographicComponent } from './main/influencer/new-influencer-demographic/new-influencer-demographic.component';
import { DemographicBarChartComponent } from './main/influencer/new-influencer-demographic/demographic-bar-chart/demographic-bar-chart.component';
import { NewGroupSettingsComponent } from './main/group-details/new-group-settings/new-group-settings.component';
import { AutoGroupSourcesComponent } from './main/group-details/new-group-settings/auto-group-sources/auto-group-sources.component';
import { AutoGroupSourceItemComponent } from './main/group-details/new-group-settings/auto-group-sources/auto-group-source-item/auto-group-source-item.component';
import { AutoGroupFilterBoxComponent } from './main/group-details/new-group-settings/auto-group-filter-box/auto-group-filter-box.component';
import { AutoGroupFiltersComponent } from './main/group-details/new-group-settings/auto-group-filters/auto-group-filters.component';
import { AutoGroupFilterItemComponent } from './main/group-details/new-group-settings/auto-group-filters/auto-group-filter-item/auto-group-filter-item.component';
import { NotificationSettingComponent } from './main/account-setting/user-settings/notification-setting/notification-setting.component';
import { ChannelFollowersComponent } from './main/influencer/influencer-insight/channel-followers/channel-followers.component';
import { BulkUploadInfluencerComponent } from './main/bottombar-influencer-fragement/bulk-upload-influencer/bulk-upload-influencer.component';
import { BulkUploadInfluencerModalComponent } from './main/bottombar-influencer-fragement/bulk-upload-influencer/bulk-upload-influencer-modal/bulk-upload-influencer-modal.component';
import { InvalidTokenComponent } from './auth/invalid-token/invalid-token.component';
import { BlurryBackdropImageComponent } from './core/blurry-backdrop-image/blurry-backdrop-image.component';
import { PostImageComponent } from './main/influencer/post-list/post-image/post-image.component';
import { NotFoundPageComponent } from './mmi/not-found-page/not-found-page.component';
import { SupportFormComponent } from './mmi/support-form/support-form.component';
import { InfluencerReviewComponent } from './main/admin/influencer-review/influencer-review.component';
import { DismissInfluencerPopupComponent } from './main/admin/influencer-review/dismiss-influencer-popup/dismiss-influencer-popup.component';
import { EmailSettingsComponent } from './main/email-settings/email-settings.component';
import { AdvertiserAppAuthGuard } from './core/advertiser-app-auth.guard';
import { InactiveAccountComponent } from './auth/inactive-account/inactive-account.component';
import { UserMonthlyUsageComponent } from './main/user/user-billing/user-monthly-usage/user-monthly-usage.component';
import { PostTypeDisplayComponent } from './main/post-overview/post-type-display/post-type-display.component';
import { LatestPostsComponent } from './main/influencer/influencer-overview/latest-posts/latest-posts.component';
import { LatestPostItemComponent } from './main/influencer/influencer-overview/latest-posts/latest-post-item/latest-post-item.component';
import { LatestPostsPlacholderComponent } from './main/influencer/influencer-overview/latest-posts/latest-posts-placeholder/latest-posts-placeholder.component';
import { BrandMentionsComponent } from './main/influencer/influencer-overview/brand-mentions/brand-mentions.component';
import { FollowerGrowthComponent } from './main/influencer/influencer-insight/follower-growth/follower-growth.component';
import { SponsoredVsOrganicComponent } from './main/influencer/influencer-overview/sponsored-vs-organic/sponsored-vs-organic.component';
import { InfluencerPostsComponent } from './main/influencer/influencer-overview/influencer-posts/influencer-posts.component';
import { InfluencerModulePlaceholderComponent } from './main/influencer/influencer-module-placeholder/influencer-module-placeholder.component';
import { InfluencerPostsPlaceholderComponent } from './main/influencer/influencer-overview/influencer-posts/influencer-posts-placeholder/influencer-posts-placeholder.component';
import { InfluencerModuleContainerComponent } from './main/influencer/influencer-module-container/influencer-module-container.component';
import { PopularTopicsComponent } from './main/influencer/influencer-overview/popular-topics/popular-topics.component';
import { PerformanceTimelineComponent } from './main/influencer/influencer-insight/performance-timeline/performance-timeline.component';
import { NewKpiItemPlaceholderComponent } from './main/influencer/new-kpi/new-kpi-item-placeholder/new-kpi-item-placeholder.component';
import { InfluencerTopExposureItemComponent } from './main/influencer/influencer-insight/influencer-top-exposures/influencer-top-exposure-item/influencer-top-exposure-item.component';
import { InfluencerTopExposureItemPlaceholderComponent } from './main/influencer/influencer-insight/influencer-top-exposures/influencer-top-exposure-item-placeholder/influencer-top-exposure-item-placeholder.component';
import { InfluencerTopExposuresComponent } from './main/influencer/influencer-insight/influencer-top-exposures/influencer-top-exposures.component';
import { BestPerformingPostsComponent } from './main/influencer/influencer-insight/best-performing-posts/best-performing-posts.component';
import { BestPerformingPostItemComponent } from './main/influencer/influencer-insight/best-performing-posts/best-performing-post-item/best-performing-post-item.component';
import { BestPerformingPostsPlacholderComponent } from './main/influencer/influencer-insight/best-performing-posts/best-performing-posts-placeholder/best-performing-posts-placeholder.component';
import { InteractionRateByChannelComponent } from './main/influencer/influencer-insight/interaction-rate-by-channel/interaction-rate-by-channel.component';
import { FollowerByChannelComponent } from './main/influencer/influencer-insight/follower-by-channel/follower-by-channel.component';
import { ChannelReachComponent } from './main/influencer/influencer-insight/channel-reach/channel-reach.component';
import { ChannelReachItemComponent } from './main/influencer/influencer-insight/channel-reach/channel-reach-item/channel-reach-item.component';
import { InteractionRateDevelopmentComponent } from './main/influencer/influencer-insight/interaction-rate-development/interaction-rate-development.component';
import { RelatedInfluencersComponent } from './main/influencer/influencer-overview/related-influencers/related-influencers.component';
import { RelatedInfluencerItemComponent } from './main/influencer/influencer-overview/related-influencers/related-influencer-item/related-influencer-item.component';
import { PrintLatestPostsPlaceholderComponent } from './main/influencer/influencer-insight/latest-posts-placeholder/print-latest-posts-placeholder.component';
import { NonSsoAuthGuard } from './core/non-sso-auth.guard';
import { ExportInfluencerComponent } from './main/export-influencer/export-influencer.component';
import { ExportInfluencerService } from './main/services/export-influencer.service';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

declare var require: any;
export function highchartsFactory() {
  const hc = require('highcharts');
  const hcm = require('highcharts/highcharts-more');
  const solidGauge = require('highcharts/modules/solid-gauge');
  const hcBorder = require('highcharts-border-radius/index');
  hcm(hc);
  solidGauge(hc);
  hcBorder(hc);
  return hc;
}
const DEFAULT_DROPZONE_CONFIG: DropzoneConfigInterface = {
  url: 'http://ws.getachoo.com/campaign/uploadFile',
  maxFilesize: 50,
  acceptedFiles: 'image/*'
};

@NgModule({
  imports: [
    RouterModule,
    BrowserModule,
    NgSelectModule,
    CommonModule,
    HttpClientModule,
    NgHttpLoaderModule,
    AppRouteModule,
    FormsModule,
    ReactiveFormsModule,
    InfiniteScrollModule,
    NgxPermissionsModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    NgMasonryGridModule,
    ChartModule,
    NgbModule.forRoot(),
    AchooModalDialogModule.forRoot(),
    IonRangeSliderModule,
    ClickOutsideModule,
    NgDragDropModule.forRoot(),
    NgxPopperModule,
    DropzoneModule,
    ColorPickerModule,
    // Segment Importation
    SegmentModule.forRoot({ apiKey: environment.segmentToken, debug: true }),
    ServiceWorkerModule.register('/ngsw-worker.js', {
      enabled: environment.production && navigator instanceof Object && 'serviceWorker' in navigator
    }),
  ],
  declarations: [
    AppComponent,
    LoginComponent,
    VersionComponent,
    MainComponent,
    DiscoverComponent,
    DashboardComponent,
    InfluencerHomeComponent,
    DashboardOrderBarComponent,
    RecentMessagesComponent,
    ShortMessageComponent,
    ResetComponent,
    AuthComponent,
    AchooChipsComponent,
    AchooTabComponent,
    AchooTabsComponent,
    AchooDropdownComponent,
    AchooCheckboxComponent,
    AchooToggleSwitchComponent,
    AchooFilterBoxComponent,
    AchooUserAvatarComponent,
    GroupDetailsComponent,
    GroupDetailsBreadcumbComponent,
    SearchBarComponent,
    InfluencerItemComponent,
    AchooTextFieldComponent,
    AchooPopupComponent,
    AddInfluencerGroupComponent,
    AutoSuggestionInfluencerComponent,
    AchooTextareaComponent,
    InfluencerGroupsComponent,
    InfluencerComponent,
    InfluencerOverviewComponent,
    PostListComponent,
    AchooPieChartComponent,
    AchooColumnChartComponent,
    InfluencerBasicInformationComponent,
    ThousandNumberSuffixPipe,
    GaugeCircleChartComponent,
    InfluencerInsightComponent,
    PlatformReacheComponent,
    TopExposuresComponent,
    TopExposureItemComponent,
    BestPerformingExposureComponent,
    BestPerformingExposureItemComponent,
    TopMentionComponent,
    PercentNumberSuffixPipe,
    FilterInfluencerGroupNameSuffixPipe,
    CurrencySymbolismPipe,
    PostOverviewComponent,
    PostContentComponent,
    SameInfluencerTopFivePostsComponent,
    RelatedPostsComponent,
    KpiReportComponent,
    AchooGaugeCircleChartComponent,
    AchooLineChartComponent,
    InfluencerDemographicsComponent,
    GroupItemComponent,
    AchooMaterialInputComponent,
    AchooMaterialTextareaComponent,
    DiscoverSearchComponent,
    GenderPerAgeChartComponent,
    CampaignItemComponent,
    CampaignInfluencersItemComponent,
    CampaignInfluencersListComponent,
    AddInfluencerCampaignComponent,
    TabInkBarDirective,
    TabLabelWrapperDirective,
    CheckAccountLevelsDirective,
    CampaignsAddComponent,
    CampaignsEditComponent,
    CampaignsComponent,
    SelectableCampaignTermsComponent,
    CampaignTermComponent,
    UploadFileComponent,
    ContenteditableDirective,
    SpinnerComponent,
    AchooChipComponent,
    AchooLoaderComponent,
    AchooPlaceholderComponent,
    AchooMaterialTextareaComponent,
    AdminComponent,
    AchooIframeComponent,
    UserProfileComponent,
    InfluencerCampaignComponent,
    MeasureComponent,
    MeasureBreadcumbComponent,
    MeasureFilterComponent,
    MeasureModulesSelectionComponent,
    TabHeadingDirective,
    NgTranscludeDirective,
    AchooInfiniteScrollComponent,
    PreviewSelectedInfluencersComponent,
    AddInfluencersToCampaignComponent,
    PreviewInfluencerItemComponent,
    MoveInfluencerFromGroupComponent,
    ActivityFiltersComponent,
    AchooSliderComponent,
    FormatNumberToStringPipe,
    AchooValidationAlertsComponent,
    ChannelOpportunitiesReportComponent,
    MentionTimelineReportComponent,
    AchooStackedColumnChartComponent,
    MeasureSettingComponent,
    CurrencyPipe,
    FileSizePipe,
    InteractionReportComponent,
    InteractionReportItemComponent,
    MarketDrillDownComponent,
    AchooGaugeCircleChartContentComponent,
    RoiReportComponent,
    TopicDrillDownComponent,
    ListGaugeCircleChartComponent,
    AverageBenchmarkPerformanceReportComponent,
    IndustryDrillDownReportComponent,
    InfluencerOverviewReportComponent,
    InfluencerSummarizeComponent,
    ExposureKpiReportComponent,
    AchooKpiReportItemComponent,
    AchooValidationAlertsComponent,
    BestPerformingInfluencerComponent,
    TopPerformingInfluencerComponent,
    MeasureContentComponent,
    ProjectSelectionComponent,
    EditProjectComponent,
    AchooKeyworkInputFieldComponent,
    BillingComponent,
    ChangePasswordComponent,
    InfluencerOverviewPostContentComponent,
    BottombarInfluencerFragementComponent,
    AddPostsToProjectComponent,
    PreviewFileComponent,
    CreateGroupFragmentComponent,
    OrderBarComponent,
    InfluencerCampaignActivityComponent,
    CampaignInfluencerStatusSliderComponent,
    CampaignInfluencerPostsComponent,
    AchooPaginationComponent,
    RoiSettingComponent,
    CampaignCustomTermDetailsComponent,
    RegisterComponent,
    TelephoneNumberFormatDirective,
    RequestDemoComponent,
    PdfViewerComponent,
    InfluencerDetailPdfViewerComponent,
    PdfViewerHeaderComponent,
    PdfViewerFooterComponent,
    PostOverviewPdfViewerComponent,
    ListPlatformReachComponent,
    PlatformReachItemComponent,
    MeasurePdfViewerComponent,
    FilterDataByIdPipe,
    RequestDemoComponent,
    PlatformSettingsComponent,
    AchooColorPickerComponent,
    AchooDropzoneComponent,
    AchooColorFieldComponent,
    DemographicHypeAuditorComponent,
    AchooBarChartComponent,
    DemographicComponent,
    DemographicSourceSelectionComponent,
    AchooPieChartPlacholderComponent,
    DemographicFallbackComponent,
    PayAsYouGoComponent,
    CreditSummaryComponent,
    ActivityPricingComponent,
    CreditUsageComponent,
    BillingDetailsComponent,
    PayAsYouGoBreadcumbComponent,
    UsageItemComponent,
    ListInvoicesComponent,
    InvoiceItemComponent,
    CreditUsageListComponent,
    InvoiceListComponent,
    AchooDatepickerComponent,
    ManageUserCreditComponent,
    ManageUserAndBillingComponent,
    UpdateCreditUsageComponent,
    AddUserCreditComponent,
    UploadInvoiceComponent,
    AchooColorFieldComponent,
    AddInfluencerManuallyComponent,
    AchooRadioButtonComponent,
    StatusInfluencerSuggestionComponent,
    TopMentionPlaceholderComponent,
    AchooColumnChartPlaceholderComponent,
    PlatformReachPlaceholderComponent,
    TopExposurePlaceholderComponent,
    BestPerformingExposurePlaceholderComponent,
    AchooGaugeChartPlaceholderComponent,
    LatestPostItemPlaceholderComponent,
    TopExposureItemPlaceholderComponent,
    AchooBarChartPlaceholderComponent,
    AchooColumnChartPlaceholderComponent,
    AudienceFilterComponent,
    InterestFilterComponent,
    SignUpComponent,
    VerifyNewAccountComponent,
    SignUpFormComponent,
    ConfirmPasswordComponent,
    OonaReportComponent,
    OonaReportItemComponent,
    AchooIndexStatusComponent,
    TopPostPlaceholderComponent,
    AddNotesComponent,
    InlineEditNoteComponent,
    AchooStoryPreviewComponent,
    AchooDatepickerRangeComponent,
    MeasureDateRangeSelectionComponent,
    MeasureModuleDropdownComponent,
    AchooIconTooltipComponent,
    CampaignNewComponent,
    CampaignDetailsComponent,
    InfoGroupComponent,
    CampaignStatusSliderComponent,
    FbTestingPageComponent,
    FbLoginFailComponent,
    CampaignPostListComponent,
    CampaignPostItemComponent,
    InfluencerDetailsComponent,
    InfluencerSignUpComponent,
    InfluencerLoginComponent,
    InfluencerAuthComponent,
    InfluencerInboxComponent,
    ConservationListComponent,
    ConversationItemComponent,
    InfluencerCampaignDetailComponent,
    InfluencerSettingsComponent,
    InfluencerMainComponent,
    ForwardComponent,
    MeasurePdfExportComponent,
    PageCountItemComponent,
    InfluencerOverviewTabComponent,
    MessagePopupComponent,
    PlatformSelectComponent,
    InfluencerInsightModalComponent,
    InfluencerOverviewDetailPopupComponent,
    PostListMansonryComponent,
    AddScriptBlogComponent,
    AchooModalComponent,
    PlatformFieldComponent,
    ImagePrepoadDirective,
    InfluencerChatComponent,
    ChatScrollerDirective,
    CampaignPdfViewerComponent,
    InfluencerConnectionComponent,
    ContactPermissionComponent,
    ContactPermissionDetailComponent,
    InfluencerAllSetComponent,
    FbAuthSuccessDeligatorComponent,
    CampaignAcceptionPopupComponent,
    InfluencerConfirmationComponent,
    InfluencerDeclineModalComponent,
    FailRetrieveCampaignModalComponent,
    SignUpErrorComponent,
    InfluencerListComponent,
    MonthlyVisitedBreadcrumbComponent,
    SendToReviewComponent,
    NewKpiComponent,
    NewKpiItemComponent,
    InvalidAccountLevelNotificationComponent,
    FormatInteractionNumberPipe,
    FormatInteractionPercentagePipe,
    UserUsagePipe,
    UserBillingComponent,
    AccountTypeComponent,
    AccountSettingComponent,
    UserSettingsComponent,
    UserDetailsComponent,
    ChangePwdComponent,
    DemographicGenderChartComponent,
    NewGenderPerAgeChartComponent,
    DemographicBarChartComponent,
    NewInfluencerDemographicComponent,
    NewGroupSettingsComponent,
    AutoGroupSourcesComponent,
    AutoGroupSourceItemComponent,
    AutoGroupFilterBoxComponent,
    AutoGroupFiltersComponent,
    AutoGroupFilterItemComponent,
    NotificationSettingComponent,
    ChannelFollowersComponent,
    BulkUploadInfluencerComponent,
    BulkUploadInfluencerModalComponent,
    InvalidTokenComponent,
    BlurryBackdropImageComponent,
    ImpactFilterSuffixPipe,
    PostImageComponent,
    NotFoundPageComponent,
    SupportFormComponent,
    InfluencerReviewComponent,
    DismissInfluencerPopupComponent,
    EmailSettingsComponent,
    InactiveAccountComponent,
    UserMonthlyUsageComponent,
    PostTypeDisplayComponent,
    LatestPostsComponent,
    LatestPostItemComponent,
    LatestPostsPlacholderComponent,
    BrandMentionsComponent,
    FollowerGrowthComponent,
    SponsoredVsOrganicComponent,
    InfluencerPostsComponent,
    InfluencerModulePlaceholderComponent,
    InfluencerPostsPlaceholderComponent,
    InfluencerModuleContainerComponent,
    PopularTopicsComponent,
    PerformanceTimelineComponent,
    NewKpiItemPlaceholderComponent,
    InfluencerTopExposureItemComponent,
    InfluencerTopExposureItemPlaceholderComponent,
    InfluencerTopExposuresComponent,
    BestPerformingPostsComponent,
    BestPerformingPostItemComponent,
    BestPerformingPostsPlacholderComponent,
    InteractionRateByChannelComponent,
    FollowerByChannelComponent,
    ChannelReachComponent,
    ChannelReachItemComponent,
    InteractionRateDevelopmentComponent,
    RelatedInfluencersComponent,
    RelatedInfluencerItemComponent,
    PrintLatestPostsPlaceholderComponent,
    ExportInfluencerComponent
  ],
  providers: [
    GroupService,
    UserService,
    CampaignService,
    HttpClient,
    HttpClientModule,
    InfluencerService,
    InfluencerPostService,
    ReferenceDataService,
    InfluencerGroupsService,
    CommonService,
    AuthorizeService,
    ForgotPasswordService,
    DiscoverService,
    CampaignService,
    AuthGuard,
    AdvertiserAppAuthGuard,
    NonSsoAuthGuard,
    LoginGuard,
    PdfGuard,
    PdfDeactivateGuard,
    UserBillingGuard,
    LevelsGuard,
    InfluencerGuard,
    CampaignGuard,
    AuthService,
    ThemeService,
    MentionService,
    PlaceholderVisibilityService,
    {
      provide: HighchartsStatic,
      useFactory: highchartsFactory
    },
    BaseService,
    MockBaseService,
    NgbActiveModal,
    ModalService,
    ValidationHandlerService,
    MeasureService,
    DatePipe,
    ProjectService,
    CacheService,
    PdfViewerService,
    PdfExportService,
    CreditBaseBillingService,
    {
      provide: DROPZONE_CONFIG,
      useValue: DEFAULT_DROPZONE_CONFIG
    },
    EventTrackerService,
    AdminService,
    DashboardService,
    OverviewService,
    CommunicationService,
    ExportInfluencerService,
  ],
  bootstrap: [AppComponent]
})
export class SharedModule {
  constructor(private injector: Injector) {
    ServiceLocator.injector = injector;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared.module.ts